/**
 * Portal waits (auth boot, billing recovery, in-page reloads) draw the shared
 * work-tree loader as an overlay, so a boot that walks portal gates into the
 * work tree never swaps loading visuals mid-flight.
 */
import LoadingScreen from '@x9/web-work/components/LoadingScreen';

export default function PortalLoader() {
  return <LoadingScreen overlay />;
}
